import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { ReactNode } from 'react';
import RedesignImage from '../../../../shared/components/RedesignImage';
import { useResultDetailCardStyles } from './ResultDetailCard.styles';

type ResultDetailCardProps = {
  label: string;
  color: string;
  labelColor?: string;
  imageSrc?: string;
  imageAlt?: string;
  title?: string;
  subtitle?: string;
  onLearnMore?: () => void;
  imageOverlay?: ReactNode;
};

const ResultDetailCard = ({
  label,
  color,
  labelColor,
  imageSrc,
  imageAlt = '',
  title,
  subtitle,
  onLearnMore,
  imageOverlay,
}: ResultDetailCardProps) => {
  const classes = useResultDetailCardStyles();

  return (
    <article className={classes.detailCard}>
      <div
        className={classes.detailCardHeader}
        style={{ backgroundColor: color, color: labelColor }}>
        {label}
      </div>
      <div className={classes.detailCardBody}>
        <div className={classes.detailCardImageWrapper}>
          {imageSrc ? (
            <RedesignImage src={imageSrc} alt={imageAlt} className={classes.detailCardImage} />
          ) : (
            <div className={classes.detailCardImagePlaceholder} />
          )}
          {imageOverlay}
        </div>
        {(title || subtitle) && (
          <div>
            {title && <p className={classes.detailCardTitle}>{title}</p>}
            {subtitle && <p className={classes.detailCardSubtitle}>{subtitle}</p>}
          </div>
        )}
        {onLearnMore && (
          <button type="button" className={classes.detailCardButton} onClick={onLearnMore}>
            En savoir plus
            <ArrowForwardIcon className={classes.detailCardArrow} />
          </button>
        )}
      </div>
    </article>
  );
};

export default ResultDetailCard;
